import { IFundSource } from './fund-source';

/**
 * Model representing the fund sources available for a ping account.
 */
export interface IFundSources {
    /**
     * The current available ping balance for use in funding a purchase.
     */
    readonly availableBalance?: number;
    /**
     * The collection of credit/debit card or bank account funding sources
     */
    readonly fundSources?: Array<IFundSource>;
}
